export default class VisibilityToggle {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('change', (e) => {
				VisibilityToggle.getElements(e, el);
			});
		});
	}

	static getElements(e, el) {
		const target = e.target.dataset.elementToToggle;
		const state = e.target.dataset.setState;
		const name = el.getAttribute('name');
		if (name != null) {
			const targetElements = document.querySelectorAll(`[data-target="${name}"]`);
			VisibilityToggle.resetAllElements(targetElements);
			if (targetElements.length === 1) {
				VisibilityToggle.setToggleTarget(targetElements, target);
			}
		}
		VisibilityToggle.toggleVisibility({
			target,
			state,
		});
	}

	static toggleVisibility({ target, state }) {
		const targetElement = document.querySelector(`[data-toggle-target="${target}"]`);
		if (targetElement != null) {
			if (state === 'true') {
				targetElement.classList.add('is-visible');
			} else if (state === 'false') {
				targetElement.classList.remove('is-visible');
			} else {
				targetElement.classList.toggle('is-visible');
			}
		}
	}

	static resetAllElements(targetElements) {
		if (targetElements != null) {
			targetElements.forEach((element) => element.classList.remove('is-visible'));
		}
	}

	static setToggleTarget(targetElements, target) {
		targetElements.forEach((el) => el.setAttribute('data-toggle-target', target));
	}
}
